import React, { useEffect, useLayoutEffect, Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import Scrollspy from "react-scrollspy";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import FooterTwo from "../component/footer/FooterTwo";
import Helmet from "../component/common/Helmet";
import { IoIosUnlock } from "react-icons/io";
import logoXrai from "../assets/images/logo/xrailogo.png";
import "../css/BorderTable.css";
import {
  ActionButtonWrapper,
  BorderPwTitle,
  ComentButton,
  FlexBox,
  FreeSizeBox,
  InputBackBox,
  InquiryBox,
  InquiryGroupBox,
  ListButton,
  LockIcon,
  PwBackBox,
  PwButton,
  PwButton2,
  ReReplysButton,
  ReSaveButton,
  RelpsPaddingBox,
  RelpysBox,
  RelpysComentBox,
  RelpysFlexCenter,
  RelpysFont614,
  RelpysSpan,
  RelpysText,
  RelpysTimeBox,
  ReplysSB,
  Spinner2,
  SpinnerWrapper2,
} from "../css/BorderPageStyle";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { apiKeyState } from "../atom/ApiKey";
import { apiProductsState } from "../atom/Products";
import { getCookie, removeCookie } from "../util/Cookie";
import { TokenName, getTimeAgoText } from "../util/Common";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  BorderDelete,
  BorderGetApi,
  CommentCreat,
  CommentCreat2,
  CommentDelete,
  CommentPut,
} from "../api/border/BorderApi";
import { ListJoinState, boardListState } from "../atom/BorderPage";
import DeleteModal from "../component/modal/DeleteModal";
import { MdSubdirectoryArrowRight } from "react-icons/md";

const BorderPassword = () => {
  const location = useLocation();
  const history = useHistory();
  const item = location.state?.item;
  const [isPw, setPw] = useState("");
  const [isPwError, setPwError] = useState(false);
  const [isSave, setSave] = useState(false);
  const [isData, setData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [isCreateRe, setIsCreateRe] = useState("");
  const [isWriter, setWriter] = useState(true);

  const [editingId, setEditingId] = useState(null);
  const [editContent, setEditContent] = useState(""); // 수정 input 값

  const [reEditionId, setReEditionId] = useState(null);
  const [reEditContent, setReEditContent] = useState("");
  const handleClose = () => {
    setOpenModal(false);
  };

  const handleReSave = () => {
    history.push({
      pathname: "/inputPage",
      state: { data: isData },
    });
  };

  useLayoutEffect(() => {
    const { hash } = location;
    if (hash) {
      const target = document.getElementById(hash.substring(1));
      if (target) {
        console.log(hash, target);
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location]);

  const menuTrigger = () => {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  };

  const closeMenuTrigger = () => {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  };

  useEffect(() => {
    const handleScroll = () => {
      var value = window.scrollY;
      if (value > 100) {
        document.querySelector(".header--fixed").classList.add("sticky");
      } else {
        document.querySelector(".header--fixed").classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    const elements = document.querySelectorAll(".has-droupdown > a");
    for (let i = 0; i < elements.length; i++) {
      elements[i].onclick = function () {
        this.parentElement.querySelector(".submenu").classList.toggle("active");
        this.classList.toggle("open");
      };
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const logo = {
    // width: "20%",
    width: `150px`,
  };
  const setApiKeys = useSetRecoilState(apiKeyState);
  const setPriducts = useSetRecoilState(apiProductsState);
  const [isToken, setToken] = useState(false);
  const setListJoinState = useSetRecoilState(ListJoinState);
  const listJoin = useRecoilValue(ListJoinState);
  const joinState = useRecoilValue(ListJoinState);

  useEffect(() => {
    const token = getCookie(TokenName);

    if (!token) {
      setToken(true);
    } else {
      setToken(false);
    }
  }, []);

  const fetchData = async (id, pw, token) => {
    try {
      setLoading(true);
      const resp = await BorderGetApi(id, pw, false);
      if (resp?.response?.status === 400) {
        setPwError(true);
        return;
      }

      if (resp.status === 200) {
        const modifiedData = {
          ...resp.data,
          is_token: true,
          password: pw,
        };
        setListJoinState((prev) => {
          const exists = prev.some((item) => item.id === modifiedData.id);
          if (exists) {
            return prev.map((item) =>
              item.id === modifiedData.id ? modifiedData : item
            );
          } else {
            return [...prev, modifiedData];
          }
        });

        setData(modifiedData);
        setSave(true);
        setLoading(false);
      }
    } catch (error) {
      console.log("비밀번호 입력 오류", error);
      setPwError(true);
      return;
    }
  };

  useEffect(() => {
    const run = async () => {
      const matchedItem = joinState.find((entry) => entry.id === item.id);
      if (matchedItem) {
        if (matchedItem.is_token === true) {
          await fetchData(matchedItem.id, matchedItem.password, false);
          // setSave(true);
          // setLoading(false);
        } else {
          setSave(false);
        }
      } else {
        setSave(false);
      }
    };

    const Manager = async (id, token) => {
      try {
        const safeToken = token ?? "";
        const resp = await BorderGetApi(id, safeToken, true);
        if (resp?.response?.status === 400) {
          // setPwError(true);
          // console.log("로그인은 되어있지만 관리자가 아님", resp);
          // console.log("현재 리스트 정보", listJoin);
          // return;
          run();
        }

        if (resp.status === 200) {
          const modifiedData = {
            ...resp.data,
            is_token: true,
            password: "Manager",
          };
          setWriter(false);
          setListJoinState((prev) => {
            const exists = prev.some((item) => item.id === modifiedData.id);
            if (exists) {
              return prev.map((item) =>
                item.id === modifiedData.id ? modifiedData : item
              );
            } else {
              return [...prev, modifiedData];
            }
          });
          setData(modifiedData);
          setSave(true);
          setLoading(false);
        }
      } catch (error) {
        console.log("관리자 확인용 관리자가 아님", error);
        setPwError(true);
        setSave(false);
        setLoading(false);
      }
    };

    const token = getCookie(TokenName);
    if (token) {
      Manager(item?.id, token);
    } else {
      run();
    }
  }, []);
  const handleRepleyDelete = async (id) => {
    try {
      if (!isData?.replys) return;

      const deleteTargets = isData.replys
        .filter((reply) => reply.id === id || reply.parent_id === id)
        .map((r) => r.id);

      for (let deleteId of deleteTargets) {
        const resp = await CommentDelete(deleteId);
        if (resp.status !== 200) {
          console.log("삭제 실패:", deleteId);
          return;
        }
      }

      const updatedReplies = isData.replys.filter(
        (reply) => !deleteTargets.includes(reply.id)
      );

      setData((prev) => ({
        ...prev,
        replys: updatedReplies,
      }));

      setListJoinState((prevList) =>
        prevList.map((item) =>
          item.id === isData.id
            ? {
                ...item,
                replys: updatedReplies,
              }
            : item
        )
      );
    } catch (error) {
      console.log("댓글삭제 Error", error);
    }
  };

  const handleRepleyCreate = async (id, content, writer, sbid) => {
    try {
      const resp = await CommentCreat(id, content, writer, sbid);

      if (resp.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.log("댓글 생성 Error", error);
      return;
    }
  };
  const haderLogout = () => {
    localStorage.clear();
    setApiKeys([]);
    setPriducts([]);
    setListJoinState([]);
    removeCookie(TokenName);
    history.push("/login");
  };

  const handleList = () => {
    history.push("/border");
  };
  const [isFocused, setIsFocused] = useState(false);

  const handleBorder = () => {
    history.push("/border");
  };

  const handleInput = async (id, pw, token) => {
    if (!pw || pw.trim() === "") {
      setPwError(true);
      return;
    }

    try {
      const resp = await BorderGetApi(id, pw, token);
      if (resp?.response?.status === 400) {
        setPwError(true);
        return;
      }

      if (resp.status === 200) {
        const modifiedData = {
          ...resp.data,
          is_token: true,
          password: pw,
        };

        const isDuplicate = listJoin.some(
          (item) => item.id === modifiedData.id
        );

        if (!isDuplicate) {
          setListJoinState((prev) => [...prev, modifiedData]);
          setData(modifiedData);
          setSave(true);
        } else {
          console.log("이미 존재하는 항목입니다. 추가하지 않음");
        }
      }
    } catch (error) {
      console.log("비밀번호 입력 오류", error);
      setPwError(true);
      return;
    }
  };

  const handleChangePw = (e) => {
    setPw(e.target.value);
  };

  useEffect(() => {
    const resp = getCookie(TokenName);
  }, []);

  const handleDelete = async (id) => {
    setOpenModal(true);
  };
  const handleHardReset = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleRepleyPut = async (id, content) => {
    try {
      const resp = await CommentPut(id, content);

      if (resp.status === 200) {
        const now = new Date().toISOString();

        setData((prev) => {
          if (!prev || !prev.replys) return prev;

          const updatedReplies = prev.replys.map((reply) =>
            reply.id === id
              ? {
                  ...reply,
                  content: content,
                  created_at: now,
                }
              : reply
          );

          setEditingId(null);

          return {
            ...prev,
            replys: updatedReplies,
          };
        });
      }
    } catch (error) {
      console.log("댓글 수정 Error", error);
    }
  };
  const handleReRepleyCreat = async (id, content, writer, sbid) => {
    try {
      const resp = await CommentCreat2(id, content, writer, sbid);
      if (resp.status === 200) {
        const now = new Date().toISOString();

        const newReply = {
          ...resp.data,
          content: content,
          parent_id: id, // ✅ 대댓글이므로 parent_id 설정
          writer: writer ? "글쓴이" : "관리자",
          created_at: resp.data.created_at || now,
          id: resp.data,
        };

        // ✅ isData 업데이트
        setData((prev) => {
          const updatedReplies = [...(prev?.replys || []), newReply];
          return {
            ...prev,
            replys: updatedReplies,
          };
        });

        setListJoinState((prevList) => {
          return prevList.map((item) => {
            if (item.id === sbid) {
              const updatedReplies = [...(item.replys || []), newReply];
              return {
                ...item,
                replys: updatedReplies,
              };
            }
            return item;
          });
        });

        // 입력창 초기화 및 대댓글창 닫기
        setReEditContent("");
        setReEditionId(null);
      }
    } catch (error) {
      console.log("대댓글 달기 실패 Error ", error);
      return;
    }
  };

  return (
    <Fragment>
      <Helmet pageTitle="XRAI | (주)엑스알에이아이" />
      {/* Start Header Area  */}
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">
                <img
                  className="logo-1"
                  style={logo}
                  src={logoXrai}
                  alt="Logo Images"
                />
                <img className="logo-2" src={logoXrai} alt="Logo Images" />
              </a>
              {/* <div onClick={() => handleHardReset()}>ds</div> */}
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <Scrollspy
                className="mainmenu"
                items={["home", "border", "contact"]}
                // currentClassName="is-current"
                offset={-200}
              >
                <li>
                  <a
                    style={{
                      cursor: `pointer`,
                    }}
                    onClick={() => history.push("/")}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a href="/#company">Company</a>
                </li>
                <li>
                  <a href="/#solution">Solution</a>
                </li>
                <li>
                  <a href="/#portfolio">Portfolio</a>
                </li>
                <li>
                  <a
                    style={{
                      color: `#ffc20e`,
                      cursor: `pointer`,
                    }}
                  >
                    Contact
                    <hr
                      color={`#ffc20e`}
                      style={{
                        height: `4px`,
                      }}
                    />
                  </a>
                </li>
                <li>
                  {isToken === true ? (
                    <a href="login">Login</a>
                  ) : (
                    <a
                      style={{
                        cursor: `pointer`,
                      }}
                      onClick={() => haderLogout()}
                    >
                      Logout
                    </a>
                  )}
                </li>
              </Scrollspy>
            </nav>
            {/* <div className="header-btn">
              <a
                className="rn-btn"
                href="https://themeforest.net/checkout/from_item/25457315?license=regular"
              >
                <span>buy now</span>
              </a>
            </div> */}
            {/* Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span onClick={menuTrigger} className="menutrigger text-white">
                <FiMenu />
              </span>
            </div>
            {/* End Humberger Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span onClick={closeMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>

      <div className="about-area ptb--120 bg_color--5">
        <div className="about-wrapper">
          <div
            className="container"
            style={{
              display: `flex`,
              justifyContent: `center`,
              alignItems: `center`,
              minHeight: `60vh`,
              flexDirection: `column`,
            }}
          >
            <BorderPwTitle>
              <div
                style={{
                  display: `flex`,
                  width: `100%`,
                  paddingTop: `20px`,
                  paddingBottom: `20px`,
                  paddingLeft: `20px`,
                  paddingRight: `20px`,
                  justifyContent: `space-between`,
                  alignItems: `center`,
                  backgroundColor: `white`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    alignItems: `center`,
                  }}
                >
                  <div
                    style={{
                      borderBottom: `3px solid #ffc20e`,
                      fontWeight: `800`,
                      fontSize: `16px`,
                    }}
                  >
                    {item?.category_name}
                  </div>
                  <div style={{ marginLeft: `20px` }}>
                    <div
                      style={{
                        fontSize: `10px`,
                        color: `gray`,
                      }}
                    >
                      {item?.company}
                    </div>
                    <div
                      style={{
                        display: `flex`,
                        alignItems: `center`,
                      }}
                    >
                      <div
                        style={{
                          fontSize: `16px`,
                          fontWeight: `700`,
                        }}
                      >
                        {item.title}
                      </div>
                      <LockIcon>
                        <IoIosUnlock />
                      </LockIcon>
                    </div>
                  </div>
                </div>

                <div>
                  {" "}
                  {(() => {
                    const d = new Date(item.created_at);
                    return `${d.getFullYear()}-${String(
                      d.getMonth() + 1
                    ).padStart(2, "0")}-${String(d.getDate()).padStart(
                      2,
                      "0"
                    )} ${String(d.getHours()).padStart(2, "0")}:${String(
                      d.getMinutes()
                    ).padStart(2, "0")}`;
                  })()}
                </div>
              </div>
            </BorderPwTitle>
            <FreeSizeBox height="5vh" />
            {isLoading === true ? (
              <SpinnerWrapper2>
                <Spinner2 />
              </SpinnerWrapper2>
            ) : (
              <div
                style={{
                  width: `100%`,
                }}
              >
                {isSave === true ? (
                  <>
                    <div
                      style={{
                        backgroundColor: `white`,
                        width: `100%`,
                        // minHeight: `200px`,
                        border: `1px solid #F6F6F6`,
                        borderRadius: `16px`,
                        padding: `20px`,
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginTop: "10px",
                          fontSize: "16px",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                textAlign: `center`,
                                padding: "8px",
                                fontWeight: "bold",
                                width: "15%",
                                borderRight: `1px solid #F6F6F6`,
                              }}
                            >
                              문의
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "30%",
                              }}
                            >
                              {isData?.category_name}
                            </td>
                            <td
                              style={{
                                textAlign: `center`,
                                padding: "8px",
                                fontWeight: "bold",
                                width: "15%",
                                borderRight: `1px solid #F6F6F6`,
                              }}
                            >
                              담당자
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "30%",
                              }}
                            >
                              {isData?.phone}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                textAlign: `center`,
                                padding: "8px",
                                fontWeight: "bold",
                                width: "15%",
                                borderRight: `1px solid #F6F6F6`,
                              }}
                            >
                              회사명
                            </td>
                            <td
                              style={{
                                padding: "8px",
                              }}
                            >
                              {isData?.company}
                            </td>
                            <td
                              style={{
                                textAlign: `center`,
                                padding: "8px",
                                fontWeight: "bold",
                                width: "15%",
                                borderRight: `1px solid #F6F6F6`,
                              }}
                            >
                              이메일
                            </td>
                            <td
                              style={{
                                padding: "8px",
                              }}
                            >
                              {isData?.email}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                textAlign: `center`,
                                padding: "8px",
                                fontWeight: "bold",
                                width: "15%",
                                borderRight: `1px solid #F6F6F6`,
                              }}
                            >
                              연락처
                            </td>
                            <td
                              style={{
                                padding: "8px",
                              }}
                            >
                              {isData?.phone}
                            </td>
                            <td
                              style={{
                                textAlign: `center`,
                                padding: "8px",
                                fontWeight: "bold",
                                width: "15%",
                                borderRight: `1px solid #F6F6F6`,
                              }}
                            >
                              타이틀
                            </td>
                            <td
                              style={{
                                padding: "8px",
                              }}
                            >
                              {isData?.title}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div
                        dangerouslySetInnerHTML={{ __html: isData?.content }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: `20px`,
                        display: `flex`,
                        justifyContent: `space-between`,
                        alignItems: `center`,
                        width: `100%`,
                      }}
                    >
                      <ListButton onClick={() => handleList()}>목록</ListButton>
                      <div
                        style={{
                          display: `flex`,
                        }}
                      >
                        <div
                          style={{
                            marginRight: `10px`,
                            cursor: `pointer`,
                            fontSize: `12px`,
                          }}
                          onClick={() => handleReSave()}
                        >
                          수정
                        </div>
                        <div
                          style={{
                            fontSize: `12px`,
                            cursor: `pointer`,
                          }}
                          onClick={() => handleDelete(isData?.id)}
                        >
                          삭제
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        border: `1px solid black`,
                        width: `100%`,
                        borderRadius: `8px`,
                        marginTop: `20px`,
                        padding: `10px 20px`,
                        backgroundColor: `#FCFCFC`,
                      }}
                    >
                      <div
                        style={{
                          fontSize: `16px`,
                          fontWeight: `700`,
                          marginBottom: `10px`,
                        }}
                      >
                        댓글
                      </div>
                      <textarea
                        value={isCreateRe}
                        onChange={(e) => setIsCreateRe(e.target.value)}
                        style={{
                          padding: `20px`,
                        }}
                      ></textarea>
                      <div
                        style={{
                          width: `100%`,
                          display: `flex`,
                          justifyContent: `end`,
                        }}
                      >
                        <ListButton
                          onClick={() =>
                            handleRepleyCreate(
                              null,
                              isCreateRe,
                              isWriter,
                              isData?.id
                            )
                          }
                          style={{
                            marginTop: `20px`,
                            marginBottom: `10px`,
                          }}
                        >
                          등록
                        </ListButton>
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    style={{
                      width: `100%`,
                      display: `flex`,
                      flexDirection: `column`,
                      justifyContent: `center`,
                      // backgroundColor: `red`,
                      alignItems: `center`,
                    }}
                  >
                    <div
                      style={{
                        fontWeight: `800`,
                        fontSize: `32px`,
                        color: `#ffc20e`,
                      }}
                    >
                      비밀번호
                    </div>
                    <div
                      style={{
                        fontSize: `16px`,
                        fontWeight: `600`,
                      }}
                    >
                      문의 등록시 설정하신 비밀번호를 입력해주세요.
                    </div>
                    <InputBackBox isFocused={isFocused}>
                      <IoIosUnlock
                        color="gray"
                        size={`30px`}
                        style={{
                          marginRight: `5px`,
                          marginLeft: `5px`,
                        }}
                      />
                      <input
                        checked={isPw}
                        onChange={handleChangePw}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleInput(item.id, isPw, item.is_token);
                          }
                        }}
                        style={{
                          width: "100%",
                          border: "none",
                          outline: "none",
                          fontSize: "16px",
                        }}
                        type="password"
                      ></input>
                    </InputBackBox>
                    {isPwError === true && (
                      <div
                        style={{
                          marginTop: `10px`,
                          color: `red`,
                        }}
                      >
                        <div>비밀번호를 확인해주세요.</div>
                      </div>
                    )}
                    <PwBackBox>
                      <PwButton2 onClick={() => handleBorder()}>목록</PwButton2>
                      <div
                        style={{
                          width: `20px`,
                        }}
                      ></div>
                      <PwButton
                        onClick={() =>
                          handleInput(item.id, isPw, item.is_token)
                        }
                      >
                        입력
                      </PwButton>
                    </PwBackBox>
                  </div>
                )}
              </div>
            )}
            {isLoading === false && (
              <div
                style={{
                  width: `100%`,
                }}
              >
                {isData?.replys?.length > 0 && (
                  <RelpysBox>
                    <RelpysComentBox>
                      <RelpysSpan>Comments</RelpysSpan>
                    </RelpysComentBox>
                    {/* <div
                      style={{
                        height: `20px`,
                      }}
                    ></div> */}
                    {isData.replys
                      .filter(
                        (reply) =>
                          reply.parent_id == null || reply.parent_id === ""
                      )
                      .map((parent) => {
                        const childReplies = isData.replys.filter(
                          (r) => r.parent_id === parent.id
                        );

                        const parentTime = new Date(parent.created_at);
                        const formattedParentTime = `${parentTime.getHours()}:${String(
                          parentTime.getMinutes()
                        ).padStart(2, "0")}`;

                        return (
                          <RelpsPaddingBox key={parent.id}>
                            {/* 댓글 */}
                            <ReplysSB>
                              <RelpysFlexCenter>
                                <RelpysFont614>{parent.writer}</RelpysFont614>
                                <RelpysTimeBox>
                                  {getTimeAgoText(parent.created_at)}
                                </RelpysTimeBox>
                              </RelpysFlexCenter>

                              <ActionButtonWrapper className="action-buttons">
                                <>
                                  {(!isWriter ||
                                    (parent.writer === "글쓴이" &&
                                      isWriter)) && (
                                    <>
                                      <ReReplysButton
                                        onClick={() => {
                                          setEditingId((prev) =>
                                            prev === parent.id
                                              ? null
                                              : parent.id
                                          );
                                          setReEditionId(null);
                                          setEditContent(parent.content);
                                        }}
                                      >
                                        {editingId === parent.id ? (
                                          <>닫기</>
                                        ) : (
                                          <>수정</>
                                        )}
                                      </ReReplysButton>

                                      <ReReplysButton
                                        onClick={() =>
                                          handleRepleyDelete(parent.id)
                                        }
                                      >
                                        삭제
                                      </ReReplysButton>
                                    </>
                                  )}
                                </>

                                {/* ✅ 댓글 버튼은 항상 노출 */}
                                <ReReplysButton
                                  onClick={() => {
                                    setReEditionId((prev) =>
                                      prev === parent.id ? null : parent.id
                                    );
                                    setEditingId(null);
                                  }}
                                >
                                  {reEditionId === parent.id ? (
                                    <>닫기</>
                                  ) : (
                                    <>댓글</>
                                  )}
                                </ReReplysButton>
                              </ActionButtonWrapper>
                            </ReplysSB>

                            <RelpysText>{parent.content}</RelpysText>
                            {editingId === parent.id && (
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: `10px`,
                                  marginTop: `10px`,
                                }}
                              >
                                <input
                                  value={editContent}
                                  onChange={(e) =>
                                    setEditContent(e.target.value)
                                  }
                                  style={{
                                    width: `100%`,
                                  }}
                                />
                                <ReSaveButton
                                  onClick={() =>
                                    handleRepleyPut(parent.id, editContent)
                                  }
                                >
                                  수정
                                </ReSaveButton>
                              </div>
                            )}
                            {reEditionId === parent.id && (
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: `10px`,
                                  marginTop: `10px`,
                                }}
                              >
                                <input
                                  value={reEditContent}
                                  onChange={(e) =>
                                    setReEditContent(e.target.value)
                                  }
                                  style={{ width: "100%" }}
                                />
                                <ReSaveButton
                                  onClick={() =>
                                    handleReRepleyCreat(
                                      parent.id,
                                      reEditContent,
                                      isWriter,
                                      isData?.id
                                    )
                                  }
                                >
                                  등록
                                </ReSaveButton>
                              </div>
                            )}

                            {/* 대댓글 */}
                            {childReplies.map((child) => {
                              return (
                                <div key={child.id}>
                                  <ReplysSB>
                                    <RelpysFlexCenter>
                                      <MdSubdirectoryArrowRight />
                                      <RelpysFont614>
                                        {child.writer}
                                      </RelpysFont614>
                                      <RelpysTimeBox>
                                        {getTimeAgoText(child.created_at)}
                                      </RelpysTimeBox>
                                    </RelpysFlexCenter>
                                    <ActionButtonWrapper className="action-buttons">
                                      {(!isWriter ||
                                        (child.writer === "글쓴이" &&
                                          isWriter)) && (
                                        <ReReplysButton
                                          onClick={() => {
                                            setEditingId((prev) =>
                                              prev === child.id
                                                ? null
                                                : child.id
                                            );
                                            setEditContent(child.content);
                                            setReEditionId(null); // 대댓글 창 닫기
                                          }}
                                        >
                                          {editingId === child.id
                                            ? "닫기"
                                            : "수정"}
                                        </ReReplysButton>
                                      )}

                                      {(!isWriter ||
                                        (child.writer === "글쓴이" &&
                                          isWriter)) && (
                                        <ReReplysButton
                                          onClick={() =>
                                            handleRepleyDelete(child.id)
                                          }
                                        >
                                          삭제
                                        </ReReplysButton>
                                      )}

                                      <ReReplysButton
                                        onClick={() => {
                                          setReEditionId((prev) =>
                                            prev === child.id ? null : child.id
                                          );
                                          setEditingId(null); // 수정 창 닫기
                                        }}
                                      >
                                        {reEditionId === child.id
                                          ? "닫기"
                                          : "댓글"}
                                      </ReReplysButton>
                                    </ActionButtonWrapper>
                                  </ReplysSB>

                                  {/* 대댓글 내용 */}
                                  <RelpysText style={{ marginLeft: `15px` }}>
                                    {child.content}
                                  </RelpysText>

                                  {/* 수정 input */}
                                  {editingId === child.id && (
                                    <div
                                      style={{
                                        display: "flex",
                                        margin: "10px 0",
                                      }}
                                    >
                                      <input
                                        value={editContent}
                                        onChange={(e) =>
                                          setEditContent(e.target.value)
                                        }
                                        style={{ width: "100%" }}
                                      />
                                      <ReSaveButton
                                        onClick={() =>
                                          handleRepleyPut(child.id, editContent)
                                        }
                                      >
                                        수정
                                      </ReSaveButton>
                                    </div>
                                  )}

                                  {/* 대댓글 작성 input (대댓글의 대댓글) */}
                                  {reEditionId === child.id && (
                                    <div
                                      style={{
                                        display: "flex",
                                        margin: "10px 0",
                                      }}
                                    >
                                      <input
                                        value={reEditContent}
                                        onChange={(e) =>
                                          setReEditContent(e.target.value)
                                        }
                                        style={{ width: "100%" }}
                                      />
                                      <ReSaveButton
                                        onClick={() => {
                                          handleReRepleyCreat(
                                            parent.id,
                                            reEditContent,
                                            isWriter,
                                            isData?.id
                                          );
                                        }}
                                      >
                                        등록
                                      </ReSaveButton>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </RelpsPaddingBox>
                        );
                      })}
                  </RelpysBox>
                )}
              </div>
            )}
          </div>
        </div>
        <DeleteModal
          isOpen={isOpenModal}
          onClose={handleClose}
          deleteId={isData?.id}
        />
      </div>
      <FooterTwo />
      {/* End Footer Style  */}
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </Fragment>
  );
};

export default BorderPassword;
